import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    loading: false,
    items: [
      {
        speech:
          '如你在港鐵範圍內遺失或留下個人物品，請填寫失物登記表，我們會儘快跟進你的個案；你亦可於三個工作天後透過「失物處理情況」功能，查看最新跟進情況。 如有任何疑問，請到金鐘站失物及乘車優惠辦事處，或大圍站或兆康站失物及乘車優惠辦事處查詢，我們樂意提供協助。各辦事處服務時間為每日上午8時至晚上8時,乘客亦可於辦公時間內致電 28610020。如在港鐵範圍內拾獲任何物品，乘客可於下車或轉車時交予該車站的港鐵職員。',
        script:
          '如你在港鐵範圍內遺失或留下個人物品，請填寫失物登記表，我們會儘快跟進你的個案；你亦可於三個工作天後透過「失物處理情況」功能，查看最新跟進情況。 如有任何疑問，請到金鐘站失物及乘車優惠辦事處，或大圍站或兆康站失物及乘車優惠辦事處查詢，我們樂意提供協助。各辦事處服務時間為每日上午8時至晚上8時,乘客亦可於辦公時間內致電 28610020。如在港鐵範圍內拾獲任何物品，乘客可於下車或轉車時交予該車站的港鐵職員。'
      },
      {
        speech: '港鐵都會票於67個指定市區車站適用，40日內搭40程，只售435元，為每天中長途過海返工的乘客度身訂造，慳得更多更輕鬆！',
        script:
          '港鐵都會票於67個指定市區車站適用，40日內搭40程，只售$435，為每天中長途過海返工的乘客度身訂造，慳得更多更輕鬆！ 使用港鐵都會票，要注意... 請保留收據，作日後查詢或處理車票失效之用。 緊記於購票當日起計14日內作首次使用。 切勿把車票與八達通或其他車票放在一起，以方便閘機辨認車票。 請小心使用，不要屈曲或用力擠壓車票，以免令車票失效。 車票用法簡單，只需「拍票入閘，插票出閘」即可。而車票將於第40程出閘時被收回 (於尖沙咀或尖東站出閘除外)。 使用車票於30分鐘內在尖沙咀及尖東站轉綫，將不會被扣額外車程。'
      },
      {
        speech: '港鐵旅遊票可於任何1天* 無限次乘搭港鐵、輕鐵及港鐵巴士。 (但不包括機場快綫、東鐵綫，以及來往羅湖或落馬洲站)',
        script:
          '港鐵旅遊票可於任何1天* 無限次乘搭港鐵、輕鐵及港鐵巴士 (機場快綫、東鐵綫頭等，以及來往羅湖或落馬洲站除外) - 全日通只限非香港居民並直至購票當日為止在香港逗留少於14天的遊客使用 *「任何1天」是指由首次車程的入閘時間起計算24小時內'
      }
    ]
  },
  mutations: {
    SET_MESSAGE_LOADING(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    async pushMessage({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.posting_message'), loading: true })

        const response = await api.pushMessage(payload)
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.message_posted'), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
